import us from './locales/en-us.js';
import id from './locales/id-id.js';
import vn from './locales/vi-vn.js';
import th from './locales/th-th.js';

export default function (lang) {
  if (lang === 'en-us') {
    return us;
  } else if (lang === 'id-id') {
    return id;
  } else if (lang === 'vi-VN') {
    return vn;
  } else if (lang === 'th-TH') {
    return th;
  }
  return us;
}



// WEBPACK FOOTER //
// ./src/bu/pc/lang.js